import { PathWithId } from "@constellation-academy/epic-ui";
import { OrderEditPath } from "../order-edit/order-edit.paths";

export class OrdersPath extends PathWithId<typeof OrdersPath> {
	static readonly pathKey = "orders";
	static readonly idKey = "orderId";
	static readonly childPaths = [OrderEditPath];
}
